export default __webpack_public_path__ + "static/logo-swiss-augenchirurgie-fbfa07a44a93bd06aefa286f40cfd940.png";